module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"cs":{"BranchSelector":{"button":"Vyhledat","placeholder":"Zadejte vaše město, PSČ nebo název pobočky."}},"en":{"BranchSelector":{"button":"Search","placeholder":"Enter your city, zip code, or branch name."}}}')
  delete Component.options._Ctor
}
